export default "__VITE_ASSET__B$zoZ52D__"